// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.non-business-tooltip .warning-icon {
  color: #cc3b26 !important;
}
.non-business-tooltip .warning-icon svg {
  width: 12px;
  height: 12px;
}
`, "",{"version":3,"sources":["webpack://./app/non-business-tooltip/non-business-tooltip.less"],"names":[],"mappings":"AAEA;EAGI,yBAAA;AAHJ;AAAA;EAMM,WAAA;EACA,YAAA;AAHN","sourcesContent":["@import (reference) \"../../../css/unison\";\n\n.non-business-tooltip {\n  .warning-icon {\n    // TODO: Should this use primary? It was orange but is a warning\n    color: @cu-color-error !important;\n\n    svg {\n      width: 12px;\n      height: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
